/// <reference path="../typings/index.d.ts" />


module monitoringApp {
    angular.module("ultimateMonitoringApp", ['ngMaterial', 'ngResource', 'common.services', 'chart.js', 'nvd3', 'angular.filter'])
        .config(
        ($interpolateProvider: angular.IInterpolateProvider,
            $mdThemingProvider: angular.material.IThemingProvider,
            $mdDateLocaleProvider: angular.material.IDateLocaleProvider) => {
            $interpolateProvider.startSymbol('[[');
            $interpolateProvider.endSymbol(']]');
            $mdThemingProvider.theme('default')
                .primaryPalette('green', {
                    'default': '400',
                    'hue-1': '400'
                }).accentPalette('blue-grey', {
                    default: '500',
                    'hue-1': '100'
                });
            $mdThemingProvider.theme('dark')
                .primaryPalette('grey', {
                    'default': '100'
                }).accentPalette('blue', {
                    default: '500'
                })
                .dark();
            //passed, failed, pending
            $mdDateLocaleProvider.formatDate = function (date) {
                //@ts-ignore
                return moment(date).format('YYYY-MM-DD');
            };

        });
}
